/* eslint-disable react/require-default-props */
import React from "react";

interface BrandMarkProps {
  size?: "sm" | "md" | "lg";
  className?: string;
}

const sizes = {
  sm: { box: "h-6 w-6", icon: "h-3.5 w-3.5", text: "text-sm" },
  md: { box: "h-7 w-7", icon: "h-4 w-4", text: "text-base" },
  lg: { box: "h-9 w-9", icon: "h-5 w-5", text: "text-lg" },
};

export default function BrandMark({
  size = "md",
  className = "",
}: BrandMarkProps) {
  const s = sizes[size];
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`.trim()}>
      <span
        className={`flex items-center justify-center rounded-lg bg-blue-700 dark:bg-blue-600 ${s.box}`}
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          className={`stroke-blue-50 dark:stroke-white ${s.icon}`}
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M5 12.5 L10 17 L19 7" />
        </svg>
      </span>
      <span
        className={`font-medium text-blue-900 dark:text-gray-100 ${s.text}`}
      >
        Digar
      </span>
    </span>
  );
}
